snap-logo {
  display: block;
}

.snap-logo {
  display: flex;

  &--white {
    svg path {
      fill: white;
    }
  }
}
